<script>
export default {
    name: "PrintPrescription",

    data() {

        return {
            patient: {},
            prescriptions: [],
        };
    },

    mounted() {

        Promise.all([ this.fetchPatient(), this.fetchPrescriptions(), ]).then(() => {
            window.print();
            window.onafterprint = () => window.close();
            window.oncancel = () => window.close();
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(({ data }) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchPrescriptions() {
            let url = `MedicalFile/GetPatientPrescriptionOrdersforGivenDate`;
                url += `?PatientId=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;
                url += `&OrderDate=${this.$moment().format(`YYYY-MM-DD`)}`;

            return this.$http.get(url).then(({ data }) => {
                this.prescriptions = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
          
        <div class="w-full flex flex-wrap max-h-8 overflow-auto border-b-2 border-t-2 border-gray-800" >
                              <div class="md:w-1/3 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Name: 
                                        <span class="font-bold">{{ patient.names }}</span></h5>
                              </div>
                              
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">IPFile NO: 
                                        <span class="font-bold">{{ patient.ipfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">OPFile NO: 
                                        <span class="font-bold">{{ patient.opfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">MRN: 
                                         <span class="font-bold">{{ patient.patienT_ID }}</span></h5>
                              </div>
                             <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Age: 
                                         <span class="font-bold">{{ patient.age }} Yr(s)</span></h5>
                              </div> 
                          </div>
       <h5 class="w-full font-bold text-center">PATIENT PRESCRIPTION ORDER</h5>
       <tail-stamp></tail-stamp>
        <div class="w-full overflow-visible">
            <table class="table">
                <thead class="text-xs font-bold">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Drug</th>
                        <th class="p-tiny">Prescription</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Issued Qty</th>
                        <!-- <th class="p-tiny">Req By</th> -->
                        
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-xs font-bold" v-for="(pres, idx) in prescriptions" :key="idx">
                        <td class="p-tiny">{{ pres.date | dateFormat }}</td>
                        <td class="p-tiny">{{ pres.service }}</td>
                        <td class="p-tiny">{{ pres.prescription }}</td>
                        <td class="p-tiny">{{ pres.qtyOrdered }}</td>
                        <td class="p-tiny">{{ pres.qtyIssued }}</td>
                        <!-- <td class="p-tiny">{{ pres.userName }}</td> -->
                    </tr>
                </tbody>
            </table>
        </div><div class="w-full flex flex-wrap p-1 my-1 border-t-2 border-gray-800">
            
            <div class="w-full p-1 text-right">
                <h5 class="text-sm font-bold">Printed By: {{ $root.username }}</h5>
            </div>
            <tail-signature></tail-signature> </div>
    </div>
</template>